// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
  position: relative;
  width: 23rem;
  height: 23rem;
  perspective: 500px;
  transform-style: preserve-3d;
}

.card-container {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotateY(calc(var(--offset) * 50deg)) scaleY(calc(1 + var(--abs-offset) * -0.4)) translateZ(calc(var(--abs-offset) * -30rem)) translateX(calc(var(--direction) * -5rem));
  filter: blur(calc(var(--abs-offset) * 1rem));
  transition: all 0.3s ease-out;
}

.card {
  width: 100%;
  height: 100%;
  padding: 2rem;
  background-color: hsl(280deg, 40%, calc(100% - var(--abs-offset) * 50%));
  border-radius: 1rem;
  color: #9CA3AF;
  text-align: justify;
  transition: all 0.3s ease-out;
}
.card h2 {
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  margin: 0 0 0.7em;
  color: #1F2937;
}
.card p, .card h2 {
  transition: all 0.3s ease-out;
  opacity: var(--active);
}

.nav {
  color: white;
  font-size: 5rem;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  z-index: 2;
  cursor: pointer;
  user-select: none;
  background: unset;
  border: unset;
}
.nav.left {
  transform: translateX(-100%) translatey(-50%);
}
.nav.right {
  right: 0;
  transform: translateX(100%) translatey(-50%);
}`, "",{"version":3,"sources":["webpack://./src/components/RecCarousel/RecCarousel.scss"],"names":[],"mappings":"AAOA;EACE,kBAAA;EACA,YALU;EAMV,aANU;EAOV,kBAAA;EACA,4BAAA;AANF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kLACE;EAIF,4CAAA;EACA,6BAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,wEAAA;EACA,mBAAA;EACA,cAhCW;EAiCX,mBAAA;EACA,6BAAA;AAVF;AAYE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAxCU;AA8Bd;AAaE;EACE,6BAAA;EACA,sBAAA;AAXJ;;AAeA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;AAZF;AAcE;EACE,6CAAA;AAZJ;AAeE;EACE,QAAA;EACA,4CAAA;AAbJ","sourcesContent":["$color-purple: #8B5CF6;\n$color-pink: #EC4899;\n$color-gray: #9CA3AF;\n$color-black: #1F2937;\n$card-size: 23rem;\n\n\n.carousel {\n  position: relative;\n  width: $card-size;\n  height: $card-size;\n  perspective: 500px;\n  transform-style: preserve-3d;\n}\n\n.card-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  transform: \n    rotateY(calc(var(--offset) * 50deg)) \n    scaleY(calc(1 + var(--abs-offset) * -0.4))\n    translateZ(calc(var(--abs-offset) * -30rem))\n    translateX(calc(var(--direction) * -5rem));\n  filter: blur(calc(var(--abs-offset) * 1rem));\n  transition: all 0.3s ease-out;\n}\n\n.card {\n  width: 100%;\n  height: 100%;\n  padding: 2rem;\n  background-color: hsl(280deg, 40%, calc(100% - var(--abs-offset) * 50%));\n  border-radius: 1rem;\n  color: $color-gray;\n  text-align: justify;\n  transition: all 0.3s ease-out;\n  \n  h2 {\n    text-align: center;\n    font-size: 2rem;\n    font-weight: bold;\n    margin: 0 0 0.7em;\n    color: $color-black;\n  }\n  \n  p, h2 {\n    transition: all 0.3s ease-out;\n    opacity: var(--active);\n  }\n}\n\n.nav {\n  color: white;\n  font-size: 5rem;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  z-index: 2;\n  cursor: pointer;\n  user-select: none;\n  background: unset;\n  border: unset;\n  \n  &.left {\n    transform: translateX(-100%) translatey(-50%);\n  }\n  \n  &.right {\n    right: 0;\n    transform: translateX(100%) translatey(-50%);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carousel": `carousel`,
	"card-container": `card-container`,
	"card": `card`,
	"nav": `nav`,
	"left": `left`,
	"right": `right`
};
export default ___CSS_LOADER_EXPORT___;
